import { YesObject } from '@yes.technology/react-toolkit'

export const relationColumnUuids = (rows: YesObject[]): string[] =>
  rows.map((o) => o.uuid)
